import React from 'react';
import {Button, PriorityIcon} from '@priority-software/priority-style-react';
import {getLocalizedText, texts} from '../../../../constants/TextConst';
import {withTooltip} from '../../HOC/Custom/withTooltip';
import {quickPrintLabels} from '../actions/labels';

export const PrintLabelButton = (props: any) => {
    return (
        <Button
            componentClasses="print-label"
            prefixIcon={PriorityIcon.printLabels}
            skin="text"
            onClick={() => quickPrintLabels(props.isPopup)}
        >
            {getLocalizedText(texts.printLabel)}
        </Button>
    );
};

export const PrintLabelButtonWithTooltip = withTooltip(PrintLabelButton);
